import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Wrapper Android TV / Fire TV : masque le bouton play natif du WebView (CSS ciblé)
// + coupe tout média quand l'app passe en arrière-plan (bouton Accueil de la télécommande)
if (/MayaPlus(AndroidTV|FireTV)/i.test(navigator.userAgent || "")) {
  document.body.classList.add("android-tv-wrapper");
  // Neutralise le poster par défaut du WebView (image grise avec bouton play)
  // en affichant le logo Maya+ sur fond noir avant la 1re image de chaque vidéo
  const POSTER_URL = "/video-poster.jpg";
  const fixPoster = (v) => { if (v.tagName === "VIDEO" && !v.getAttribute("poster")) v.setAttribute("poster", POSTER_URL); };
  document.querySelectorAll("video").forEach(fixPoster);
  new MutationObserver((muts) => {
    muts.forEach((m) => m.addedNodes.forEach((n) => {
      if (n.nodeType !== 1) return;
      fixPoster(n);
      if (n.querySelectorAll) n.querySelectorAll("video").forEach(fixPoster);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
  const pauseAllMedia = () => {
    document.querySelectorAll("video, audio").forEach((m) => { try { m.pause(); } catch { /* ignore */ } });
  };
  const origPlay = HTMLMediaElement.prototype.play;
  HTMLMediaElement.prototype.play = function (...args) {
    if (document.visibilityState === "hidden") return Promise.resolve(); // rien ne démarre en arrière-plan
    return origPlay.apply(this, args);
  };
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") pauseAllMedia();
  });
  window.addEventListener("pagehide", pauseAllMedia);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
